import React from 'react';
import { useAppConfig } from '../contexts/AppConfigContext.jsx';

export default function StatusBadge({ status }) {
  const { config } = useAppConfig();
  const normalised = status || 'New';
  const entry = config.statusValues.find(s => s.value === normalised)
             || config.statusValues.find(s => s.value === 'New');
  return (
    <span className={`badge ${entry?.cssClass || 'sev-3'}`}>
      <span className="dot" />
      {entry?.label || normalised}
    </span>
  );
}

export function SeverityBadge({ value }) {
  const { config } = useAppConfig();
  if (!value) return <span className="muted">—</span>;
  const entry = config.severityCodes.find(c => c.value === value);
  return (
    <span className={`badge ${entry?.cssClass || ''}`}>
      <span className="dot" />
      {value}
    </span>
  );
}

export function TreatmentBadge({ value }) {
  const { config } = useAppConfig();
  if (!value) return null;
  const upper = value.toUpperCase();
  const entry = config.treatmentTypes.find(t =>
    (t.aliases || []).some(a => upper === a.toUpperCase() || upper.includes(a.toUpperCase()))
  ) || config.treatmentTypes.find(t => t.value === value);
  // Always show the human label (e.g. "Skin Peels", not "SkinPeels"). LHR/AWI
  // carry a cssClass; the other treatments use the neutral base .badge look.
  return <span className={`badge ${entry?.cssClass || ''}`}>{entry?.label || value}</span>;
}
